<template>
	<div class="incenters">
		<div style="">
			<Commonbtn backgroundColor="#FFF" title="导出" fontSize="14px" @btnclick="StockExport"
				:src="require('@/assets/icon/daoc.png')">
			</Commonbtn>
			<Commonbtn backgroundColor="#FFF" title="导出库存天数" fontSize="14px" @btnclick="StockExportDay"
				:src="require('@/assets/icon/daoc.png')">
			</Commonbtn>
			<Commonbtn v-if="qx.update" :optional="!selectedRow" :useAutoOptional="false" backgroundColor="#FFF" title="修改" fontSize="14px" @btnclick="StockEdit"
				:src="require('@/assets/icon/icon-update.png')">
			</Commonbtn>
		</div>
		<!-- style="border: 1px solid blue;" -->
		<div class="TableWidth" v-if="!CusTypestate">
			<Commontable :loadingTable="false" @onRowClick="onRowClick" colnum=7 :tableData="tableData"
				:headerData="headerData" height="100%">
			</Commontable>
			<div class="pagination">
				<Pagination @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange"
					:total="total"></Pagination>
			</div>
		</div>
		<div class="TableWidth" v-else-if="CusTypestate">
			<Commontable :loadingTable="false" @onRowClick="onRowClick" colnum=7 :tableData="tableData"
				:headerData="headerDataTow" height="100%">
			</Commontable>
			<div class="pagination">
				<Pagination @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange"
					:total="total"></Pagination>
			</div>
		</div>
		<DialogFrom width="680px" title="新增用户" :dialogVisible="dialogVisibles" @cancel="cancel" @dialogOK="dialogOK">
			<div class="from">
				<block v-for="(item, index) of fromdataadd" :key="index">
					<Commondropdownlist :inputdata="item.inputdata" :title="item.title" :fontSize="item.fontSize"
						:color="item.color" :radiotitle1="item.radiotitle1" :radiotitle2="item.radiotitle2"
						:lablewith="item.lablewith" :placeholder="item.placeholder" :types="item.types"
						:inputtype="item.inputtype" :width="item.width" :min="item.min" :max="item.max">
					</Commondropdownlist>
				</block>
			</div>
		</DialogFrom>
		<DialogFrom width="680px" title="修改用户" :dialogVisible="dialogVisiblesedit" @cancel="canceledit"
			@dialogOK="dialogOKedit">
			<div class="from">
				<block v-for="(item, index) of fromdataedit" :key="index">
					<Commondropdownlist :inputdata="item.inputdata" :title="item.title" :fontSize="item.fontSize"
						:color="item.color" :radiotitle1="item.radiotitle1" :radiotitle2="item.radiotitle2"
						:lablewith="item.lablewith" :placeholder="item.placeholder" :types="item.types"
						:inputtype="item.inputtype" :width="item.width" :min="item.min" :max="item.max">
					</Commondropdownlist>
				</block>
			</div>
		</DialogFrom>
		<Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibledel" @cancel="canceldel" @dialogOK="dialogOKdel"
			:src="require('@/assets/icon/icon-del2.png')">
			<span
				style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要删除该菜单吗？</span>
		</Dialog>
		<Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibledeactivate" @cancel="canceldeactivate"
			@dialogOK="dialogOKdeactivate" :src="require('@/assets/icon/icon-del2.png')">
			<span
				style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要停用该菜单吗？</span>
		</Dialog>
	</div>
</template>
<script>
import Commondropdownlist from '../../../../components/common-dropdownlist.vue'
import Commontable from '../../../../components/common-table.vue'
import Commonbtn from '../../../../components/common-btn.vue'
import Pagination from '../../../../components/pagination.vue'
import DialogFrom from '../../../../components/dialog-from.vue'
import fromdata from '../fromData/add'
import fromdataedit from '../fromData/edit'
import Dialog from '../../../../components/dialog.vue'
import headerData from '../headerData/headerData'
import headerDataTow from '../headerData/headerDataTow'
import {
	CusType
} from '@/api/home'
export default {
	components: {
		Commontable,
		Commonbtn,
		Pagination,
		DialogFrom,
		Commondropdownlist,
		Dialog
	},
	props: {
		tableData: {
			type: Array,
			default: Array
		},
		total: {
			type: Number,
			default: 0
		},
		tableDataMD: {
			type: Array,
			default: Array
		},
		selectedRow: {
			type: Object,
			default: null
		}
	},
	data: function () {
		return {
			dialogVisibles: false,
			dialogVisiblesedit: false,
			dialogVisibledel: false,
			dialogVisibledeactivate: false,
			rightboo: false,
			dwonleft: false,
			CusTypestate: false,
			ptype: '',
			fromdataadd: [],
			fromdataedit: [],
			headerData: [],
			headerDataTow: [],
			qus: [],
			qx: {
				add: false,
				update: false,
				del: false,
				stopif: true,
				daoc: true,
				assignment: false,
				enabled: false,
				submit: false,
				skip: false, //跳过
				reset: false, //重置
			},
		}
	},
	mounted() {
		this.fromdataadd = JSON.parse(JSON.stringify(fromdata))
		this.fromdataedit = JSON.parse(JSON.stringify(fromdataedit))
		this.headerData = JSON.parse(JSON.stringify(headerData))
		this.headerDataTow = JSON.parse(JSON.stringify(headerDataTow))
		this.CusType()
		//console.log(this.fromdataedit, 'sadasdasdasdasdsadsad')
		let data = JSON.parse(localStorage.getItem("MenusData"))
		let NodeID = this.$route.query.NodeID
		console.log(1, data)
		data.Menus.map((item, index) => {
			if (item.NodeID == 24) {
				let ip = item.Nodes.filter(it => it.NodeID == 154)[0].Nodes;  //this.qus = 
				this.qus = ip.filter(it => it.NodeID == 28)[0].Nodes;
				console.log(2, ip, this.qus);
			}
		})
		if (this.qus) {
			this.qus.map((item, index) => {
				if (item.NodeName == 'add') {
					this.qx.add = true
				} else if (item.NodeName == 'edit') {
					this.qx.update = true
				} else if (item.NodeName == 'delete') {
					this.qx.del = true
				} else if (item.NodeName == 'stopif') {
					this.qx.del = true
				} else if (item.NodeName == 'assignment') {
					this.qx.assignment = true
				} else if (item.NodeName == 'enabled') {
					this.qx.enabled = true
				} else if (item.NodeName == 'skip') {
					this.qx.skip = true
				} else if (item.NodeName == 'reset') {
					this.qx.reset = true
				}
			})
		}

	},
	methods: {
		async CusType() {
			let {
				code,
				data
			} = await CusType({})
			if (code == 0) {
				if (data.CusCode == "") {
					this.CusTypestate = false
				} else {
					// let obj = [
					//   {
					//     prop: 'StandardCost',
					//     label: '参考价格',
					//     columnwidth: 80
					//   },
					//   {
					//     prop: 'Total',
					//     label: '参考价格合计',
					//     columnwidth: 85
					//   },
					// ]
					// obj.forEach((item, index) => {
					//   this.headerData.splice(0, 4+index,item)
					// })
					this.CusTypestate = true
				}

			}
		},
		onRowClick(val) {
			this.rowboo = true
			//console.log(val, "val")
			this.$emit("onRowClick", val)
		},
		handleCurrentChange(pageindex) {
			this.$emit('handleCurrentChange', pageindex)
		},
		StockExport() {
			this.$emit('StockExport')
		},
		StockExportDay() {
			this.$emit('StockExportDay')
		},
		StockEdit() {
			this.$emit('StockEdit')
		},
		handleSizeChange(paegSzie) {
			this.$emit('handleSizeChange', paegSzie)
		},
		commclick(type) {
			this[type] = true
		},

		adduser() {
			this.dialogVisibles = true
			//console.log(this.fromdataadd, '//console.log(this.fromdataadd)')
		},
		cancel() {
			this.dialogVisibles = false
		},
		dialogOK() {
			this.dialogVisibles = false
		},
		update() {
			this.dialogVisiblesedit = true
		},
		canceledit() {
			this.dialogVisiblesedit = false
		},
		dialogOKedit() {
			this.dialogVisiblesedit = false
		},
		del() {
			this.dialogVisibledel = true
		},
		canceldel() {
			this.dialogVisibledel = false
		},
		dialogOKdel() {
			this.dialogVisibledel = false
		},
		deactivate() {
			this.dialogVisibledeactivate = true
		},
		canceldeactivate() {
			this.dialogVisibledeactivate = false
		},
		dialogOKdeactivate() {
			this.dialogVisibledeactivate = false
		},
	}
}
</script>

<style lang="less" scoped>
.incenters {
	height: 100%;

	.pagination {
		display: flex;
		justify-content: center;
		align-items: center;
		margin-top: 16px;
		padding-bottom: 16px;
	}

	// div {
	//   margin-left: 8px;
	//   margin-right: 8px;
	//   margin-top: 5px;
	//   margin-bottom: 5px;

	// }
	.from {
		width: 100%;
	}

	.signingroles {
		height: 500px;
		width: 100%;
		// display: flex;
		// justify-content: space-between;
		// align-items: center;
		// border: 1px solid red;

		.left {
			height: 240px;
			width: 470px;
			border: 1px solid #e6e6e6;
		}

		.right {
			height: 240px;
			width: 470px;
			border: 1px solid #e6e6e6;
			// pointer-events: none;
		}
	}
}

.right-s {
	position: absolute;
	z-index: 99;
	opacity: 0.5;
	right: 21px;
	width: 470px;
	height: 240px;
	background-color: #ffffff;
	cursor: no-drop;
}

.dwonleft {
	width: 170px;
	height: 48px;
	position: absolute;
	background-color: #ffffff;
	z-index: 99;
	right: 350px;
	top: 322px;
	text-align: center;
	line-height: 48px;
	color: #333333;
	box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05),
		0px 6px 16px 0px rgba(0, 0, 0, 0.08), 0px 3px 6px -4px rgba(0, 0, 0, 0.12);
	border-radius: 2px;
	font-size: 14px;
	cursor: pointer;
}

.dwonleft:hover {
	background-color: #f0f0f0;
}
</style>
